module.exports = __webpack_public_path__ + "static/servicegrid1-4e31ef11a034c61d45da277746c6ac39.png";